import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	usersUpdateHistory: [],
};

const customersUpdateHistorySlice = createSlice({
	name: 'customersUpdateHistory',
	initialState: initialState,
	reducers: {
		setCustomersUpdateHistory: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setCustomersUpdateHistory, reset } = customersUpdateHistorySlice.actions;

export default customersUpdateHistorySlice.reducer;